module.exports = __webpack_public_path__ + "static/media/ncbm.c7e3c569.png";